import { Breakpoint } from '@root/types';
import thirdPartyUseBreakpoint from 'use-breakpoint';

export const breakpoints: { [k: string]: Breakpoint } = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

const DEFAULT_BREAKPOINT: Breakpoint = breakpoints.DESKTOP;

const config = {
  [breakpoints.MOBILE]: 0,
  [breakpoints.TABLET]: 720,
  [breakpoints.DESKTOP]: 1025,
};
const useBreakpoint = () => thirdPartyUseBreakpoint(config, DEFAULT_BREAKPOINT).breakpoint;

export default useBreakpoint;
